import type { ReactNode } from 'react';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { OfflineGate } from '@/shared/ui/brand-status';
import { ToastProvider } from './ToastProvider';

export interface AppProvidersProps {
  children: ReactNode;
  /** Set when auth session is available so light/dark preference is per user. */
  userId?: string | null;
}

/**
 * Root provider stack for the SPA. Wraps shadcn/Radix trees with DentXE theme layers:
 * - organization brand colours (account)
 * - user light/dark scheme
 *
 * Add Radix providers here (e.g. TooltipProvider) — never in feature pages.
 */
export function AppProviders({ children, userId = null }: AppProvidersProps): JSX.Element {
  return (
    <ThemeProvider userId={userId}>
      <OfflineGate>
        {children}
      </OfflineGate>
      <ToastProvider />
    </ThemeProvider>
  );
}
